import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { IDEAL_FIRST_DATE_OPTIONS } from '@/pages/Onboarding/options/IdealFirstDate/IDEAL_FIRST_DATE_OPTIONS';
import { getIdealFirstDateTitleById } from '@/pages/Onboarding/options/IdealFirstDate/utils/getIdealFirstDate';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const IdealFirstDateScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'IdealFirstDate',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const idealFirstDate = form.watch('ideal_first_date');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['ideal_first_date']>,
  ) => {
    form.setValue('ideal_first_date', option.id);
  };

  const handleNextStep = () => {
    const idealFirstDateTitle = getIdealFirstDateTitleById(idealFirstDate);
    userService.createOrUpdate({
      onboarding_data: {
        ideal_first_date: idealFirstDateTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>Your Ideal First Date?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="grid-with-icon">
          {IDEAL_FIRST_DATE_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={idealFirstDate === option.id}
              control={form.control}
              option={option}
              name="ideal_first_date"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="grid-with-icon"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!idealFirstDate}
      />
    </OnboardingPage>
  );
};
